var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPdfYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3334 1.33301L6.33337 1.33301C5.60004 1.33301 5.00004 1.93301 5.00004 2.66634V10.6663C5.00004 11.3997 5.60004 11.9997 6.33337 11.9997H14.3334C15.0667 11.9997 15.6667 11.3997 15.6667 10.6663V2.66634C15.6667 1.93301 15.0667 1.33301 14.3334 1.33301ZM8.66671 6.33301C8.66671 6.88634 8.22004 7.33301 7.66671 7.33301H7.00004L7.00004 8.66634H6.00004V4.66634H7.66671C8.22004 4.66634 8.66671 5.11301 8.66671 5.66634V6.33301ZM12 7.66634C12 8.21967 11.5534 8.66634 11 8.66634H9.33337V4.66634H11C11.5534 4.66634 12 5.11301 12 5.66634V7.66634ZM14.6667 5.66634H13.6667V6.33301H14.6667V7.33301H13.6667V8.66634H12.6667V4.66634L14.6667 4.66634V5.66634ZM7.00004 6.33301H7.66671V5.66634H7.00004V6.33301ZM3.66671 3.99967H2.33337L2.33337 13.333C2.33337 14.0663 2.93337 14.6663 3.66671 14.6663H13V13.333H3.66671L3.66671 3.99967ZM10.3334 7.66634H11V5.66634H10.3334V7.66634Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdfYellow);
export default __webpack_public_path__ + "static/media/IconPDFYellow.8d96cb0214f03a05f88728ff594e402a.svg";
export { ForwardRef as ReactComponent };